import { defineMessages } from 'react-intl-next';

export default defineMessages({
    newUserLozengeText: {
        defaultMessage: 'New',
        description: 'Text for a status lozenge that shows next to users that will be newly created',
        id: 'cv.request.create.form.user.picker.new.user',
    },
});
